const state = {
    l1: {},
    l2: {},
    l3: {},
    mb1: {},
    mb2: {},
    areaData: {},
}



const getters = {}

const actions = {}

const mutations = {
    setaqData(state, data) {
        for (var key in data) {
            state[key] = data[key]
        }
    },
    // setaqData(state, data) {
    //     for (var key in data) {
    //         state[key] = data[key]
    //     }
    // }
}
export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}
